enum FraudReviewStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  DECLINED = 'declined',
  REVIEW = 'review',
}

export default FraudReviewStatus;
